<script lang="ts" setup>
defineProps<{
  disabled: boolean,
  onClick: () => void
}>()

</script>
<template>
  <span @click="onClick" class="pit" v-tooltip.bottom="$t(disabled ? 'prolongError' : 'prolongOk')"
    :class="{ 'success hover cursor-pointer': !disabled, 'danger': disabled }">{{
      $t('modal.profiles.prolongProfile')
    }}</span>
</template>
